import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";
import { VatRateTraductionDto } from "./vatRateTraductionDto.model";

export class VatRateDto {
    idVatRate?: number;
    active?: string;
    vatRateTraductionDto?: VatRateTraductionDto[] = [];

    constructor(data?: Partial<VatRateDto>) {
        Object.assign(this, data);
    }
}

export class VatRateResponse {
    vatRateTypeDto: VatRateDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class VatRateRequest {
    vatRateDto: VatRateDto = new VatRateDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}